define([
  'react',
  'prop-types',
  'immutable',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
  'jsx!launcher/views/listbuilder/wysiwyg/components/game/SlotMachine',
], (React, PropTypes, Immutable, Component, SlotMachine) => {
  @Component()
  class Game extends React.Component {
    static propTypes = {
      api: PropTypes.object.isRequired,
      gameType: PropTypes.string,
      style: PropTypes.instanceOf(Immutable.Map),
      discountCode: PropTypes.string.isRequired,
      winningOption: PropTypes.instanceOf(Immutable.Map).isRequired,
      onFinishGameAnimation: PropTypes.func.isRequired,
    };

    static defaultProps = {
      gameType: 'slot-machine',
      style: Immutable.Map(),
    };

    constructor(props) {
      super(props);
    }

    renderSlotMachine() {
      return (
        <SlotMachine
          {...this.props}
        />
      );
    }

    render() {
      const { gameType } = this.props;

      switch (gameType) {
        case 'slot-machine':
        default:
          return this.renderSlotMachine();
      }
    }
  }

  return Game;
});
